import { inject } from "@angular/core";
import { map } from "rxjs";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { AppInfoService } from "../services/app-info.service";
import { SharedDataService } from "app/services/sharedData.service";
import { UserService } from "./user.service";



export const authGuard = (route: any, state: any) => {

console.log (`authGuard ${route}`)

  const authService = inject(AuthService);
  const userService = inject(UserService);
  const appInfo = inject(AppInfoService);
  const router = inject(Router);
  const sharedService = inject(SharedDataService);

  const isAbandonCallback = state.url.includes('abandon-callback');

  if (isAbandonCallback && route.routeConfig.path === 'billing') {
      return true;
  }

  if (route.routeConfig.path.indexOf("oauth/callback") <0 ) {
    console.log (`route ${route} just been called `)
    const queryParams = route.queryParams;     
    //console.log(JSON.stringify(queryParams));
    let val, tokenVal;
    for (let key in queryParams) {       
      if (queryParams.hasOwnProperty('orderNumber')) {        
         val = queryParams['orderNumber'];         
        // console.log(`Key: ${key}, Value: ${val}`); 
      } else if(queryParams.hasOwnProperty('tokenId')) {
        tokenVal = queryParams['tokenId'];
      }
      
    }
    //console.log('Param val'+ val)
    if(val){
      let enc = encodeURIComponent(val);
      sharedService.setReturnUrl(route.routeConfig.path + '?orderNumber='+enc);
    } else if(tokenVal) {
      let enc = encodeURIComponent(tokenVal);
      sharedService.setReturnUrl(route.routeConfig.path + '?tokenId='+enc);
    }else {
      sharedService.setReturnUrl(route.routeConfig.path);
    
      const flowId = route.queryParams['flowId'];
      if (flowId) {
        sharedService.setFlowId(flowId);
      }
    }
  }
  
  if (appInfo.token) {
    if (route.routeConfig.path.indexOf("oauth/callback") >= 0) {
     // console.log('HERE3')
      if (sharedService.getReturnUrl() !== '' && sharedService.getReturnUrl() !== 'login') {
        //console.log('HERE4 sharedService.getReturnUrl() '+ sharedService.getReturnUrl())
        let returnUrl = sharedService.getReturnUrl();
        if(returnUrl?.includes('?')) {
          let paramStr = returnUrl?.substring(returnUrl.indexOf('?')+1, returnUrl.length);
         // console.log('paramStr '+ paramStr);
          if(paramStr.includes('orderNumber=')) {
            let paramsList = paramStr.split('=');
            let qParams = { orderNumber: paramsList[1]};
            router.navigate([sharedService.getReturnUrl()],{queryParams : qParams});  
              //{ queryParams: { paramsList[0]: paramsList[1]} });  
          } else if(paramStr.includes('tokenId=')){
            let paramsList = paramStr.split('=');
            let qParams = { tokenId: paramsList[1]};
            let urlStrWithoutParam = returnUrl?.substring(0, returnUrl.indexOf('?'));
            router.navigate([urlStrWithoutParam],{queryParams : qParams}); 
          } else
            router.navigate([sharedService.getReturnUrl()]);  
        } else
          router.navigate([sharedService.getReturnUrl()]);
      } else {
        router.navigate(['']);
      }
      return false;
    } else {
       return true;
    }
  } else {
     if (typeof userService.profile !== 'undefined'
      && (isAbandonCallback ? userService.profile.ssoId !== '' : true) 
      && userService.profile.ssoId !== '' 
      && !sharedService.getReturnUrl().includes('admin-callback')
      && !sharedService.getReturnUrl().includes('manage-licenses')
      && !sharedService.getReturnUrl().includes('manage-admins')
      //&& userService.profile.fullName !== '' 
     )
     { console.log('profile is present in the auth'); return true;
    }
    return authService.getLoginUrl().pipe(
      map((response: any) => {
        window.location.assign(JSON.parse(response).url);
        return false;
      })
    );
  }
};
